import { Plus, ArrowUp, ArrowDown, Trash2 } from "lucide-react";
import { ROMAN } from "@/lib/api";
import { ImageUploader } from "./ImageUploader";
import { PhotoGrid } from "./PhotoGrid";

const uid = () => Math.random().toString(36).slice(2) + Date.now().toString(36);

export const ChaptersField = ({ value = [], onChange, cover, onCover }) => {
  const upd = (id, patch) => onChange(value.map((c) => (c.id === id ? { ...c, ...patch } : c)));
  const move = (k, d) => { const a = [...value]; [a[k], a[k + d]] = [a[k + d], a[k]]; onChange(a); };
  return (
    <div className="space-y-3" data-testid="chapters-field">
      {value.map((c, k) => (
        <div key={c.id} className="border border-slate-200 rounded-md p-3 bg-slate-50" data-testid={`chapter-edit-${k}`}>
          <div className="flex gap-2 items-center">
            <span className="text-xs text-slate-400 w-6">{ROMAN[k]}</span>
            <input className="admin-input" placeholder="Titolo capitolo (es. L'attesa)" value={c.title} onChange={(e) => upd(c.id, { title: e.target.value })} data-testid={`chapter-title-${k}`} />
            <button type="button" disabled={k === 0} onClick={() => move(k, -1)} className="p-2 text-slate-500 disabled:opacity-30"><ArrowUp size={14} /></button>
            <button type="button" disabled={k === value.length - 1} onClick={() => move(k, 1)} className="p-2 text-slate-500 disabled:opacity-30"><ArrowDown size={14} /></button>
            <button type="button" onClick={() => onChange(value.filter((x) => x.id !== c.id))} className="p-2 text-terracotta" data-testid={`chapter-remove-${k}`}><Trash2 size={14} /></button>
          </div>
          <textarea className="admin-input mt-2 min-h-[56px]" placeholder="Testo breve del capitolo (facoltativo)" value={c.text} onChange={(e) => upd(c.id, { text: e.target.value })} data-testid={`chapter-text-${k}`} />
          <div className="mt-2 flex items-center gap-3">
            <ImageUploader onUploaded={(u) => upd(c.id, { photos: [...c.photos, ...u] })} testid={`chapter-upload-${k}`} />
            <span className="text-xs text-slate-500">{c.photos.length} foto · stella = copertina della storia</span>
          </div>
          <PhotoGrid photos={c.photos} onChange={(p) => upd(c.id, { photos: p })} cover={cover} onCover={onCover} testid={`chapter-photos-${k}`} />
        </div>
      ))}
      <button type="button" onClick={() => onChange([...value, { id: uid(), title: "", text: "", photos: [] }])} className="text-sm inline-flex items-center gap-1.5 text-sagedark font-medium" data-testid="chapter-add-btn">
        <Plus size={14} /> Aggiungi capitolo
      </button>
    </div>
  );
};
